/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateQuestionTypesControllerRemoveMutationResponse, TemplateQuestionTypesControllerRemovePathParams, TemplateQuestionTypesControllerRemove401, TemplateQuestionTypesControllerRemove403, TemplateQuestionTypesControllerRemove404, TemplateQuestionTypesControllerRemove409 } from "../../models/checklistsController/TemplateQuestionTypesControllerRemove";

function getTemplateQuestionTypesControllerRemoveUrl(id: TemplateQuestionTypesControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/checklist-template-question-types/${id}` as const }  
  return res
}

/**
 * @summary Delete a checklist template question type (soft delete)
 * {@link /api/v1/checklist-template-question-types/:id}
 */
export async function templateQuestionTypesControllerRemove(id: TemplateQuestionTypesControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TemplateQuestionTypesControllerRemoveMutationResponse, ResponseErrorConfig<TemplateQuestionTypesControllerRemove401 | TemplateQuestionTypesControllerRemove403 | TemplateQuestionTypesControllerRemove404 | TemplateQuestionTypesControllerRemove409>, unknown>({ method : "DELETE", url : getTemplateQuestionTypesControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}